import { controllerModel } from 'shared';

export const filtersBottomSheetController = () => {
  const bottomSheet = controllerModel.useBottomSheet();
  const filtersBottomSheetName = 'filters-bottom-sheet-name';

  const show = () =>
    bottomSheet.show(filtersBottomSheetName, { shouldLockScroll: false });
  const hide = () => bottomSheet.hide(filtersBottomSheetName);

  return { show, hide, name: filtersBottomSheetName };
};
